import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import * as actions from '../actions/dispatcherRegisterActions';
import * as appActions from '../actions/appActions';
import * as settingsActions from '../actions/settingsActions';
import DispatcherRegisterForm from '../components/DispatcherRegisterForm';
import { gettext } from '../i18n/service';

export class DispatcherRegisterContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      city: undefined,
      country: undefined,
    };
    props.appActions.startSpinner();
    props.appActions.getCountries();
    this.submit = this.submit.bind(this);
    this.setCity = this.setCity.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.clearCity = this.clearCity.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.countries.length > 0) {
      this.props.appActions.endSpinner();
    }

    if (nextProps.disptacherRegister.error === true) {
      this.props.appActions.endSpinner();
      return this.props.showMessage({
        title: gettext('ERROR-OCCURED'),
        message: nextProps.disptacherRegister.message,
        level: 'error',
        autoDismiss: 10
      });

    } else if (nextProps.disptacherRegister.error === false) {
      this.props.appActions.endSpinner();
      this.props.showMessage({
        title: 'Dispatcher Sign Up',
        message: nextProps.disptacherRegister.data.message,
        level: 'success',
        autoDismiss: 10
      });
      this.props.actions.registerRequest();
    }
  }

  setCity(city) {
    this.setState({ cityId: city.id });
  }

  clearCity() {
    this.setState({ cityId: undefined });
  }

  setCountry(country) {
    this.setState({ countryId: country.id });
    this.props.settingsActions.fetchCitiesByCountryId(country.id);
    this.clearCity();
  }

  submit(e) {
    this.props.appActions.startSpinner();
    e.preventDefault();
    const elems = Array.from(e.target.elements);
    let fields = elems.reduce((prev, curr) => {
      if (!curr.name) {
        return prev;
      }
      prev[curr.name] = curr.type === 'checkbox' ? curr.checked : curr.value;
      if (curr.name == "company") {
        prev[curr.name] = {
          name: ""
        };
        prev[curr.name].name = curr.value;
      }
      return prev;
    }, {});
    fields.cityId = this.state.cityId;
    fields.countryId = this.state.countryId;

    if (_.isNil(fields.company) || _.isNil(fields.cityId) || _.isNil(fields.countryId) || _.isNil(fields.password) ||
      _.isNil(fields.confirmPassword) || _.isNil(fields.name) || _.isNil(fields.language) || _.isNil(fields.email) || _.isNil(fields.phone)) {
      this.props.appActions.endSpinner();
      return this.props.showMessage({
        title: gettext('ERROR-OCCURED'),
        message: 'Please fill all fields.',
        level: 'error',
        autoDismiss: 10
      });
    }
    if (fields.password != fields.confirmPassword) {
      this.props.appActions.endSpinner();
      return this.props.showMessage({
        title: gettext('ERROR-OCCURED'),
        message: 'Password does not match',
        level: 'error',
        autoDismiss: 10
      });
    }
    this.props.actions.register(fields);
  }

  render() {
    if (this.props.countries.length > 0)
      return (
        <DispatcherRegisterForm
          countries={this.props.countries}
          cities={this.props.cities}
          submit={this.submit}
          startSpinner={this.props.appActions.startSpinner}
          setCity={this.setCity}
          setCountry={this.setCountry}
          clearCity={this.clearCity}
          defaultValue={this.state.cityId}
          showMessage={this.props.showMessage}
          countryId={this.state.countryId}
          cityId={this.state.cityId}
        />
      );
    else {
      return null;
    }
  }
}

DispatcherRegisterContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  appActions: PropTypes.object.isRequired,
  settingsActions: PropTypes.object.isRequired,
  redirect: PropTypes.bool,
  history: PropTypes.object,
  showMessage: PropTypes.func.isRequired,
  countries: PropTypes.array,
  cities: PropTypes.array,
  disptacherRegister: PropTypes.object
};

function mapStateToProps(state) {
  return {
    countries: state.appReducer.countries,
    cities: state.settingsPageReducer.cities,
    error: state.loginFormReducer.error,
    request: state.loginFormReducer.request,
    loading: state.loginFormReducer.loading,
    redirect: state.loginFormReducer.redirect,
    message: state.appReducer.message,
    disptacherRegister: state.disptacherRegisterFormReducer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    appActions: bindActionCreators(appActions, dispatch),
    settingsActions: bindActionCreators(settingsActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatcherRegisterContainer);



// WEBPACK FOOTER //
// ./src/containers/DispatcherRegisterContainer.js